import Vue from "vue";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "roboto-fontface/css/roboto-condensed/roboto-condensed-fontface.css";
import Vuetify, { VSnackbar, VBtn, VIcon } from "vuetify/lib";

Vue.use(Vuetify, {
  components: {
    VSnackbar,
    VBtn,
    VIcon
  }
});

export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      dark: {
        primary: "#00B8D4",
        secondary: "#2196F3",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107"
      }
    },
    options: {
      customProperties: true
    }
  },
  icons: {
    iconfont: "md"
  }
});
